import { render, staticRenderFns } from "./ReservationPurpose.vue?vue&type=template&id=5270a366&scoped=true"
import script from "./ReservationPurpose.vue?vue&type=script&lang=js"
export * from "./ReservationPurpose.vue?vue&type=script&lang=js"
import style0 from "./ReservationPurpose.vue?vue&type=style&index=0&id=5270a366&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5270a366",
  null
  
)

export default component.exports